module.exports = __webpack_public_path__ + "img/logo.d3f25f06.svg";